import axios from 'axios';

export function addActivityLog(wid, msg, type, value) {
  // axios.post("/bot/api/" + wid + "/activityLog", { msg, type, value });
  axios.post('/bot/api/w/' + wid + '/workspace/activityLog', {
    msg,
    type,
    value,
  });
}
